import { render, staticRenderFns } from "./parmFile.vue?vue&type=template&id=a9f56e86&scoped=true&"
import script from "./parmFile.vue?vue&type=script&lang=js&"
export * from "./parmFile.vue?vue&type=script&lang=js&"
import style0 from "./parmFile.vue?vue&type=style&index=0&id=a9f56e86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f56e86",
  null
  
)

export default component.exports